import React, { useEffect, useState } from "react";
import styled from "styled-components";

import UpperBar from "../style/UpperBar";
import {
  ContentItem,
  Container,
  Underline,
  H3,
  ModalContainer,
  JWTDecoder,
} from "../style/Customer.module";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { gql } from "@apollo/client";
import { client } from "../../../client";
import { uploadFileWithPresignedUrl } from "../../../utils/s3Uploader";
import FileUploader from "../../admin/admin-document/FileUploader";

const StyledFormContainer = styled.div`
  max-width: 400px;
  // border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 10px;
  padding: 30px 20px;
  margin: 0 auto;
`;

const InquiryForm = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const enumType = {
    DOWNLOAD: "DOWNLOAD",
    PAYMENT: "PAYMENT",
    REQUEST: "REQUEST",
    ETC: "ETC",
  };

  Object.freeze(enumType);

  //DecodeToken
  const userId = JWTDecoder();

  // form
  const [formData, setFormData] = useState({
    user_id: userId,
    type: enumType.ETC,
    title: null,
    content: null,
    object_url: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    setFormData({ ...formData, [name]: updatedValue });
  };

  const cancelButton = () => (window.location.href = "/customer/records");

  const handleSubmit = (objectUrl) => {
    const CREATE_ERROR_REPORT = gql`
      mutation createErrorReport(
        $user_id: Int!
        $type: reportTypeEnum!
        $title: String!
        $content: String
        $object_url: String
      ) {
        createErrorReport(
          user_id: $user_id
          type: $type
          title: $title
          content: $content
          object_url: $object_url
        ) {
          message
        }
      }
    `;

    client
      .mutate({
        mutation: CREATE_ERROR_REPORT,
        variables: {
          user_id: parseInt(formData.user_id, 10),
          type: formData.type,
          title: formData.title,
          content: formData.content,
          object_url: objectUrl,
        },
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        console.log(res);
        alert("문의가 성공적으로 등록되었습니다.");
        window.location.href = "/customer/records";
      })
      .catch((err) => {
        console.error(err);
        alert(`문의 등록 중 오류가 발생했습니다. ${err.message}`);
      });
  };

  const handleUploadAndSubmit = async () => {
    if (!formData.title || !formData.content) {
      alert("문의 제목과 내용을 입력해주세요.");
      return;
    }

    setIsLoading(true);
    try {
      let finalObjectUrl = null;

      if (selectedFile) {
        finalObjectUrl = await uploadFileWithPresignedUrl(client, selectedFile);
      }

      handleSubmit(finalObjectUrl);
    } catch (err) {
      alert(`업로드 중 오류가 발생했습니다: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <H3>문의하기</H3>
      <Underline></Underline>
      <StyledFormContainer>
        <form>
          <FormControl>
            <InputLabel id="title"></InputLabel>
            <TextField
              label="제목"
              name="title"
              defaultValue={formData.title}
              onChange={handleChange}
              sx={{ marginBottom: 2, width: "400px" }}
            ></TextField>
          </FormControl>
          <FormControl>
            <InputLabel id="content"></InputLabel>
            <TextField
              label="내용"
              name="content"
              multiline
              rows={10}
              defaultValue={formData.content}
              onChange={handleChange}
              sx={{ marginBottom: 2, width: "400px" }}
            ></TextField>
          </FormControl>

          <FileUploader
            selectedFiles={selectedFile ? [selectedFile] : []}
            setSelectedFiles={(files) => setSelectedFile(files[0] || null)}
          ></FileUploader>

          <Button
            variant="contained"
            fullWidth
            onClick={handleUploadAndSubmit}
            disabled={isLoading}
            sx={{ mt: 2 }}
          >
            {isLoading ? "제출 중..." : "문의하기"}
          </Button>

          <Button sx={{ marginTop: "15px" }} onClick={() => cancelButton()}>
            취소
          </Button>
        </form>
      </StyledFormContainer>
    </Container>
  );
};

export default InquiryForm;
